<template>
     <div class="businessunit-admin">
        <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input id="businessunit-id" type="hidden" v-model="businessunit.id" />
             <b-row>
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Description:" 
                        label-for="businessunit-business_unit_name">
                        <b-form-input id="businessunit-business_unit_name" 
                            type="text" 
                            v-model="businessunit.business_unit_name" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Description..." />
                    </b-form-group>
                </b-col>
             </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                            <b-form-group 
                                label="Account Name:" 
                                label-for="businessunit-account_name_unit">
                                <b-form-input id="businessunit-account_name_unit" 
                                    type="text" 
                                    v-model="businessunit.account_name_unit"
                                    size="sm"
                                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                    placeholder="Account Name..." />
                            </b-form-group>
                        </b-col>
                        <b-col md="6" sm="12">
                            <b-form-group 
                                label="Bank:" 
                                label-for="businessunit-bank_name_unit">
                                <b-form-input id="businessunit-bank_name_unit" 
                                    type="text" 
                                    v-model="businessunit.bank_name_unit"
                                    size="sm"
                                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                    placeholder="Bank..." />
                            </b-form-group>
                        </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                            <b-form-group 
                                label="BIC:" 
                                label-for="businessunit-bic_unit">
                                <b-form-input id="businessunit-bic_unit" 
                                    type="text" 
                                    v-model="businessunit.bic_unit"
                                    size="sm"
                                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                    placeholder="BIC.." />
                            </b-form-group>
                        </b-col>
                        <b-col md="6" sm="12">
                            <b-form-group 
                                label="IBAN:" 
                                label-for="businessunit-iban_unit">
                                <b-form-input id="businessunit-iban_unit" 
                                    type="text" 
                                    v-model="businessunit.iban_unit"
                                    size="sm"
                                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                    placeholder="IBAN.." />
                            </b-form-group>
                        </b-col>
                </b-row>
         </b-form>
                <b-row>                   
                <b-col xs="12">
                    <b-button  
                        title="Add" 
                        size="sm" 
                        class="mt-2 mb-2 fa fa-plus" 
                        variant="dark" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo"></b-button>
                    <b-button  
                        title="Save"  
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save"></b-button>
                    <b-button  
                        title="Remove" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove"></b-button>
                    <b-button  
                        title="Back" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset"></b-button>
                    <b-button  
                    size="sm" 
                    title="Search" 
                    class="mt-2 mb-2 ml-2 fa fa-search" 
                    @click="[loadBusinesss(),toggleBusy(),showTable = !showTable]" 
                    variant="dark" 
                    v-show="mode !== 'save' && mode !== 'remove'"
                    >
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                <div class="col-sm-6">
                    <b-form-group> 
                    <input size="lg" type="text" icon="search" v-model="search" placeholder="Search for description" class="form-control">                  
                    </b-form-group>
                </div>
            <transition  name="slide" type="animation" appear>       
                <b-table 
                        :busy="isBusy"  
                        class="table-responsive" 
                        hover 
                        key="slide"  
                        head-variant="light" 
                        :per-page="perPage" 
                        :current-page="currentPage" 
                        :items="filteredList" 
                        :fields="fields">
                     <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button 
                                title="View" 
                                size="sm" 
                                variant="light" 
                                @click="loadBusiness(data.item, 'read')" 
                                class="mr-2 mt-2">
                            <i class="fa fa-drivers-license-o"></i>
                        </b-button>
                        <b-button 
                            title="Edit" 
                            size="sm" 
                            variant="light" 
                            @click="loadBusiness(data.item)" class="mr-2 mt-2">
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button 
                            title="Remove" 
                            size="sm" 
                            variant="light" 
                            @click="loadBusiness(data.item, 'remove')" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>
                </b-table>
            </transition>
            <b-pagination 
              v-model="currentPage" 
              :per-page="perPage"
              :total-rows="rows">
              </b-pagination> 
            </b-row>
      </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import {mask} from 'vue-the-mask'
var moment = require('moment')

export default {
         name: 'BusinessUnit',
            directives: {mask,moment},
                data: function() {
                return {
                    mode: 'insert',
                    search: '',
                    businessunit: {},
                    businessunits: [],
                    showTable: false,
                    showSearch: true,
                    isBusy: false,
                    currentPage: 1,
                    perPage: 5,
                    fields: [
                        { key: 'business_unit_name', label: 'Description', sortable: true },
                        { key: 'bank_name_unit', label: 'Bank', sortable: false },
                        { key: 'bic_unit', label: 'BIC', sortable: false },
                        { key: 'iban_unit', label: 'IBAN', sortable: false },
                        { key: 'actions', label: 'Ações', variant: 'secondary' }
                    ]
                }
            },
            computed: {
                user(){
                    return this.$store.state.user
                },
                compan(){
                    return this.$store.state.compan
                },
                filteredList() {
                return this.businessunits.filter(businessunit => {
                return businessunit.business_unit_name.toLowerCase().includes(this.search.toLowerCase())
                    })
                },
                icon() {
                    return this.showTable ? "fa-retweet" : "fa-search"
                },
                 rows() {
                    return this.businessunits.length
                }
            },
            methods: {
            formatDate (date) {
                return moment.utc(date).format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadBusinesss() {
                const url = `${baseApiUrl}/businessunitbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.businessunits = res.data
                     this.isBusy = false
            })
            },
            reset() {
                this.mode = 'insert'
                this.loadBusinesss()
            },
            alterModo() {
                        this.mode = 'save'
                        this.businessunit = {}
                        this.$refs.searchFocus.focus();
                },
            save() {
                const method = this.businessunit.id ? 'put' : 'post'
                const id = this.businessunit.id ? `/${this.businessunit.id}` : ''
                this.businessunit.company_id_unit = this.compan.id    
                this.businessunit.user_id_unit = this.user.id
                axios[method](`${baseApiUrl}/businessunits${id}`, this.businessunit)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                const id = this.businessunit.id
                axios.delete(`${baseApiUrl}/businessunits/${id}`)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                    })
                    .catch(showError)
            },
            loadBusiness(businessunit, mode = 'save') {
                this.mode = mode
                this.businessunit = { ...businessunit }
                this.$refs.searchFocus.focus();
            }
                
             },
            mounted() {
                this.showTable = true
            }
    }       
</script>

<style>

    

 .businessunit-admin label{
        font-size: 0.75rem;
           color: black;
    }
    .businessunit-admin select{
        font-size: 0.75rem;
    }
    .businessunit-admin input{
        font-size: 0.75rem;
    }
    .businessunit-admin textarea{
        font-size: 0.75rem;
    }
    .businessunit-admin button{
        font-size: 0.75rem;
    }
    .businessunit-admin table{
        font-size: 0.75rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
